module.exports = __webpack_public_path__ + "img/transactions_on.b6cefeaf.png";